module.exports = __webpack_public_path__ + "static/media/featured-icon-2.3ca53eca.svg";